
<div class="wrapper" >
  <header class="header">
    <app-header></app-header>

  </header>
  <app-loader></app-loader>



  <main class="content">



    <mat-tab-group id="dcn-nctm-tab"  #tabGroup (selectedTabChange)="tabChanged($event)">
      <mat-tab  label="{{'DCN Label' | translate}}">
        <div class="box" >
          @if (user) {
            <div class="box-header">
              <div class="flex-align-center px-3" style="margin-bottom:0% !important">
                <button mat-icon-button type="button" class="nav-action-btn" (click)="refreshData()">
                  <mat-icon>autorenew</mat-icon>
                  <span><u>R</u>{{'efresh' | translate}}</span>
                </button>
                @if (isJobAids && enableMulti) {
                  <button [matMenuTriggerFor]="menu" mat-icon-button type="button" class="nav-action-btn ml-auto mr-2">
                    <mat-icon>help_outline</mat-icon>
                    <span>{{'Help' | translate}}</span>
                  </button>
                }
                @if (isJobAids && !enableMulti && sdm) {
                  <a href="http://wls1.apps.shoppersdrugmart.ca:93/iwcontentStoreWeb/target/websites/english/pharmacy/esign_live/esign_live.html" target="_blank" mat-icon-button class="nav-action-btn ml-auto mr-2">
                    <mat-icon>help_outline</mat-icon>
                    <span>{{'Help' | translate}}</span>
                  </a>
                }
                @if (isJobAids && !enableMulti && lcl) {
                  <a href="https://mtcad.sharepoint.com/sites/lclFlip/en-ca/Pages/Pharmacy-Inventory-and-Supplies.aspx" target="_blank" mat-icon-button class="nav-action-btn ml-auto mr-2">
                    <mat-icon>help_outline</mat-icon>
                    <span>{{'Help' | translate}}</span>
                  </a>
                }
                @if (isJobAids && !enableMulti && pharmaphix) {
                  <a href="http://wls1:7071/iwcontentStoreWeb/target/websites/french/pharmacy/esign_live/esign_live.html" target="_blank" mat-icon-button class="nav-action-btn ml-auto mr-2">
                    <mat-icon>help_outline</mat-icon>
                    <span>{{'Help' | translate}}</span>
                  </a>
                }
                <mat-menu #menu="matMenu" >
                  @if (sdm) {
                    <a href="http://wls1.apps.shoppersdrugmart.ca:93/iwcontentStoreWeb/target/websites/english/pharmacy/esign_live/esign_live.html" target="_blank" mat-menu-item >{{'In-Store Web' | translate}}</a>
                  }
                  @if (lcl) {
                    <a href="https://mtcad.sharepoint.com/sites/lclFlip/en-ca/Pages/Pharmacy-Inventory-and-Supplies.aspx" target="_blank"  mat-menu-item  mat-menu-item >{{'Flip' | translate}}</a>
                  }
                  @if (pharmaphix) {
                    <a href="http://wls1:7071/iwcontentStoreWeb/target/websites/french/pharmacy/esign_live/esign_live.html" target="_blank"  mat-menu-item  mat-menu-item >{{'Pharmaprix' | translate}}</a>
                  }
                </mat-menu>
              </div>
              <nav mat-tab-nav-bar mat-align-tabs="center" class="app-primary-nav__tabs">
                @for (link of navLinks; track link) {
                  <a mat-tab-link
                    [routerLink]="link.path"
                    routerLinkActive #rla="routerLinkActive"
                    [active]="rla.isActive">
                    {{ link.label | translate}}
                  </a>
                }
              </nav>
            </div>
          }
          <div class="box-body">


            <router-outlet></router-outlet>

          </div>
        </div>



      </mat-tab>
      @if (userData.nctmAccess) {
        <mat-tab label="{{'NCTM Label'| translate}}"> {{'Redirecting' | translate}}...... </mat-tab>
      }
    </mat-tab-group>
  </main>
  <footer class="footer">
    <app-footer></app-footer>
  </footer>
</div>
